import { getallGroupMappingACTION } from "../../actions/group-mapping/groupMappingAction";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

const INITIAL_STATE = {
     groupMapping: {
        data: {
            data: [],
            totalRecords: 0
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        }
    },
};
const groupMappingReducer = createSlice({
    name: "GroupMapping",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetGroupMappingState(state, action) {
            state.groupMapping = INITIAL_STATE.groupMapping
        },
        SetGroupMappingData(state, action) {
            state.groupMapping = {
                ...state.groupMapping,
                data: {
                    ...state.groupMapping.data,
                    data: action.payload.data,
                    totalCount: action.payload.totalCount,
                },
                requestData: action.payload.requestData
            };
        },
        ResetActionDetails(state, action) {
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getallGroupMappingACTION.fulfilled, (state, action) => {
            state.groupMapping.data = {
                data: action.payload.Data?.Records || [],
                totalRecords: action.payload.Data?.TotalRecords || 0
            };
            console.log("action.payload", action.payload)
            state.groupMapping.apiMsg.status = action.meta.requestStatus;
            state.groupMapping.apiMsg.message = "success";
        });
        builder.addCase(getallGroupMappingACTION.pending, (state, action) => {
            state.groupMapping.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getallGroupMappingACTION.rejected, (state, action) => {
            state.groupMapping.apiMsg.message = action.error.message;
            state.groupMapping.apiMsg.status = action.meta.requestStatus;
        });

    },
});
export const { RESET, ResetGroupMappingState, SetGroupMappingData } = groupMappingReducer.actions;
export default groupMappingReducer.reducer;